module.exports = __webpack_public_path__ + "static/media/flooring-header@2x.67f67a5e.jpg";